import React, { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import useWindowScroll from '../hooks/useWindowScroll';
import logo from '../assets/logo/logo.png';

const NavigationBar = () => {
    const height = useWindowScroll();
    const [navScrollEffect, setNavScrollEffect] = useState('bg-slate-900 bg-opacity-5 px-2 py-4 md:px-6 md:py-8');
    const [logoWidth, setLogoWidth] = useState('w-12');
    const [expend, setExpend] = useState('hidden');
    useEffect(() => {
        if(height > 10){
            setNavScrollEffect('bg-slate-900 bg-opacity-95 px-2 py-2 md:px-6 md:py-5')
            setLogoWidth('w-8')
        }
        else {
            setNavScrollEffect('bg-slate-900 bg-opacity-5 px-2 py-4 md:px-6 md:py-8')
            setLogoWidth('w-12')
        }
    },[height])

    useEffect(() => {
        if(expend === 'block')  setNavScrollEffect('bg-slate-900 bg-opacity-95 px-2 py-2 md:px-6 md:py-5')
    },[expend])

    return (
        <div className="">
            <nav className={`my-nav fixed-top flex items-center justify-between flex-wrap transition-d-1s ${navScrollEffect}`}>
                <Link onClick={() => setExpend('hidden')} to="/" className='flex items-center flex-shrink-0 text-white mr-6'>
                    <div className="pr-2 animate__animated animate__zoomInUp">
                        <img src={logo} className={`p-0.5 border border-dashed border-white transition-d-1s rounded-sm ${logoWidth}`} alt='Logo'/>
                    </div>
                    {/* <span className="font-semibold text-xl tracking-tight">NAKUL DEB</span> */}
                </Link>
 
                <div className="block lg:hidden">
                    <button onClick={() => setExpend(prev => prev === 'hidden' ? 'block' : 'hidden')} className="flex items-center px-3 py-2 border rounded text-teal-200 border-teal-400 hover:text-white hover:border-white" id='menu' type="button">
                        <svg className="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
                    </button>
                </div>
                <div className={`w-full flex-grow lg:flex lg:items-center lg:w-auto transition-d-1s ${expend}`}>
                    <div className="text-sm lg:flex-grow  lg:flex lg:justify-end">
                        <NavLink onClick={() => setExpend('hidden')} to="/" className="block mt-4 lg:inline-block lg:mt-0 text-gray-50 hover:text-emerald-800 lg:mr-8 font-bold text-lg md:text-lg">Home</NavLink>
                        <NavLink onClick={() => setExpend('hidden')} to="/services" className="block mt-4 lg:inline-block lg:mt-0 text-gray-50 hover:text-emerald-800 lg:mr-8 font-bold text-lg md:text-lg">Services</NavLink>
                        <NavLink onClick={() => setExpend('hidden')} to="/our-clients" className="block mt-4 lg:inline-block lg:mt-0 text-gray-50 hover:text-emerald-800 lg:mr-8 font-bold text-lg md:text-lg">Our Clients</NavLink>
                        <NavLink onClick={() => setExpend('hidden')} to="/free-projects" className="block mt-4 lg:inline-block lg:mt-0 text-gray-50 hover:text-emerald-800 lg:mr-8 font-bold text-lg md:text-lg">Free Projects</NavLink>
                        <NavLink onClick={() => setExpend('hidden')} to="/contact" className="block mt-4 lg:inline-block lg:mt-0 text-gray-50 hover:text-emerald-800 lg:mr-8 font-bold text-lg md:text-lg">Contact</NavLink>
                        <NavLink onClick={() => setExpend('hidden')} to="/about" className="block mt-4 lg:inline-block lg:mt-0 text-gray-50 hover:text-emerald-800 lg:mr-8 font-bold text-lg md:text-lg">About</NavLink>
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default NavigationBar